import React from 'react';
import { LinearProgress } from '@mui/material';

import { ArcProgressBarProps, ArcProgressBarVariantProps } from './types';

const ArcProgressBar: React.FC<ArcProgressBarProps> & ArcProgressBarVariantProps = (props) => {
  return (
    <LinearProgress 
      sx={{ 
        height: 6, 
        borderRadius: '2px', 
        backgroundColor: 'background.paper' 
      }} 
      {...props} />
  );
};

ArcProgressBar.success = (props) => (
  <ArcProgressBar color='success' variant='determinate' {...props} />
);

ArcProgressBar.brand = (props) => (
  <ArcProgressBar
    variant="determinate"
    {...props}
    sx={{
      '&&': {
        backgroundColor: 'ghost.main', 
      },
      '& .MuiLinearProgress-bar': {
        backgroundColor: 'brand.main',
      }  ,
      ...props.sx,   
    }}
    
  />
);

function ArcProgressBarCondition(props: ArcProgressBarProps) {
  const barColor =
    props.value != null && props.value > 66
      ? 'error.main'
      : props.value != null && props.value > 33
        ? 'warning.main'
        : 'success.main';
  return (
    <ArcProgressBar
      variant="determinate"
      {...props}
      sx={{
        '&&': {
          backgroundColor: '#FFFFFF14',
        },
        '& .MuiLinearProgress-bar': {
          backgroundColor: barColor,
        },
        height: '8px',
        borderRadius: '4px',
        ...props.sx,
      }}
    />
  );
}

ArcProgressBar.condition = ArcProgressBarCondition;

export default ArcProgressBar;